<template>
    <div>
        <div class="charts-container">
            <CustomerPieChart v-show="!loading && costTypeList.length" :valueList="costTypeList"></CustomerPieChart>
            <b-skeleton type="avatar" v-if="loading" class="skeleton-size"></b-skeleton>
        </div>
        
        <b-table
            :fields="fields"
            :items="costTypes"
            :class="['gk-table gk-table--responsive gk-table--striped gk-table--headed']"
            :busy="loading"
            show-empty
            table-busy>
            <template #cell(vat_deductible)="row">
                <font-awesome-icon v-if="row.value" icon="fa fa-check" />
                <font-awesome-icon v-if="!row.value" icon="fa fa-xmark" />
            </template>
            <template #cell(q1)="row">
                {{ `€ ${row.value}` }}
            </template>
            <template #cell(q2)="row">
                {{ `€ ${row.value}` }}
            </template>
            <template #cell(q3)="row">
                {{ `€ ${row.value}` }}
            </template>
            <template #cell(q4)="row">
                {{ `€ ${row.value}` }}
            </template>
            <template #cell(total)="row">
                {{ `€ ${row.value}` }}
            </template>
            <template #head(total)>
                {{ totalColText }}
            </template>
        </b-table>
    </div>
</template>

<script>
import CustomerPieChart from '@/components/customer_insight/CustomerPieChart'

export default {
    name: "CostCategoriesTable",
    components: {CustomerPieChart},
    data() {
        return {
            fields: [
                { key: 'name', label: ''},
                { key: 'vat_deductible', label: this.$gettext('VAT Deductible'), thClass: 'text-center', tdClass: 'text-center'},
                { key: 'q1', label: this.$gettext('Q1'), thClass: 'text-right', tdClass: 'text-right'},
                { key: 'q2', label: this.$gettext('Q2'), thClass: 'text-right', tdClass: 'text-right'},
                { key: 'q3', label: this.$gettext('Q3'), thClass: 'text-right', tdClass: 'text-right'},
                { key: 'q4', label: this.$gettext('Q4'), thClass: 'text-right', tdClass: 'text-right'},
                { key: 'total', label: '', thClass: 'text-right', tdClass: 'text-right'}
            ],
            sortNameDesc: false
        }
    },
    props: {
        costTypes: {
            type: Array,
            default: () => []
        },
        totalColText: {
            type: String,
            default: () => ''
        },
        loading: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        costTypeList() {
            return this.costTypes.filter((item) => item.total > 0).map((item) => { return {'label': item.name, 'value': item.total}})
        }
    }
}
</script>

<style scoped>
.charts-container {
    padding-top: 1rem;
    padding-bottom: 1rem;
    display: flex;
    width: 100%;
    justify-content: center;
    overflow: auto;
}

.skeleton-size {
    min-width: 180px;
    width: 450px;
    height: 450px;
}
</style>